import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const viaPortoBaseUrl = apiBusSchedBaseURL + "draw/custom/viaporto/";

const viaPortoApiRoutes = {
    generate:          viaPortoBaseUrl + "generate",
};

export class ViaPortoAPI {
    static generate(selectedScheduleType, selectedLines, selectedSchedules, referenceDate, selectedStops, headerAndFooter) {
        return API.authenticatedRequest({
            url: viaPortoApiRoutes.generate,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify({
                "Type": selectedScheduleType,
                "LineIds": selectedLines,
                "ScheduleIds": selectedSchedules,
                "ReferenceDate": referenceDate,
                "HeaderAndFooter": headerAndFooter,
                "StopIds": selectedStops
            })
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/bussched/ViaPortoAPI.js